// Module
var code = "<react-component name=\"RecurringBookingEventsReport\"></react-component>\n";
// Exports
module.exports = code;